import {HomeCard, HomeRes, RecommendedCardBanners} from '@/root/models/home';

import {api} from '@/shared/utils/api';

export const getHome = () => {
  return api<HomeRes>('get', '/api/digitalcard/home');
};

export const getHomeCards = () => {
  return api<HomeCard[]>('get', '/api/digitalcard/home/cards');
};

export const getHomeRecommendCards = () => {
  return api<RecommendedCardBanners[]>('get', '/api/digitalcard/home/recommend-cards');
};

export const deleteCard = (ids: string[]) => {
  return api<void>('post', '/api/digitalcard/cards/delete', {ids});
};
